import { ModalUtils, Validation } from "@singularsystems/neo-core";
import { Neo } from "@singularsystems/neo-react";
import { observer } from "mobx-react";
import React from "react";
import { TextConstants } from "../../../Common/TextConstants";
import ManageCorporateActionEventComponentVM from "./ManageCorporateActionEventComponentVM";

interface IManageCorporateActionEventComponentProps {
    viewModel: ManageCorporateActionEventComponentVM;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageCorporateActionEventComponent extends React.Component<IManageCorporateActionEventComponentProps> {
    public render() {
        var viewModel = this.props.viewModel;

        return (
            <div>
                <Neo.Card title={TextConstants.Titles.EditCorporateActionEvent}>
                    <Neo.Form
                        model={viewModel.managedCorporateActionEvent}
                        validationDisplayMode={Validation.DisplayMode.AfterSubmit}
                        onInvalid={this.onFormInvalid}
                        onSubmit={() => this.props.onSave()}>
                        <Neo.GridLayout lg={4}>
                            <Neo.FormGroup
                                display={viewModel.managedCorporateActionEvent.meta.broker} />
                            <Neo.FormGroup
                                display={viewModel.managedCorporateActionEvent.meta.instrument} />
                            <Neo.FormGroup
                                display={viewModel.managedCorporateActionEvent.meta.dateEvent} />
                            <Neo.FormGroup bindContext={viewModel.managedCorporateActionEvent.meta.status}>
                                <Neo.AutoCompleteDropDown
                                    itemSource={viewModel.corporateActionEventsApiClient.getCorporateActionStatusListByCriteria}
                                    bind={viewModel.managedCorporateActionEvent.meta.corporateActionStatusID}
                                    bindDisplay={viewModel.managedCorporateActionEvent.meta.status}
                                    displayMember={"status"}
                                    items={viewModel.corporateActionEventsApiClient.getCorporateActionStatusListByCriteria(" ").then((arr) => arr.data.slice(0,10)
                                    .sort((x,y)=> x.status.localeCompare(y.status)))}
                                />
                            </Neo.FormGroup>
                        </Neo.GridLayout>
                        <Neo.GridLayout lg={4}>
                            <Neo.FormGroup
                                display={viewModel.managedCorporateActionEvent.meta.rawEventType} />
                            <Neo.FormGroup
                                display={viewModel.managedCorporateActionEvent.meta.rawCorporateActionType} />
                            <Neo.FormGroup
                                display={viewModel.managedCorporateActionEvent.meta.rawExchange} />
                            <Neo.FormGroup
                                display={viewModel.managedCorporateActionEvent.meta.currency} />
                        </Neo.GridLayout>
                        <Neo.GridLayout lg={2}>
                            <Neo.FormGroup
                                bind={viewModel.managedCorporateActionEvent.meta.researcherComment}
                                input={{ rows: 2 }} />
                            <Neo.FormGroup
                                bind={viewModel.managedCorporateActionEvent.meta.enactmentComment}
                                input={{ rows: 2 }} />
                        </Neo.GridLayout>
                        <div className="row customMarginTop29 float-right pr-3">
                            <Neo.Button
                                variant="primary" className="ml-3 col-md-2" isSubmit
                            >{TextConstants.Buttons.Save}</Neo.Button>
                            <Neo.Button className="ml-3 col-md-2"
                                onClick={() => this.props.onCancel()}
                                variant="secondary"
                            >{TextConstants.Buttons.Cancel}</Neo.Button>
                        </div>
                    </Neo.Form>
                </Neo.Card>
            </div>
        )
    }

    private onFormInvalid(e: React.FormEvent, justValidated?: boolean) {
        if (!justValidated) {
            ModalUtils.showMessage("Save", TextConstants.Validation.InvalidCorporateActionEvent);
        }
    }
}